import { proxy } from 'valtio';

const user = {
  id: '',
  role: '',
  customerId: '',
  firstName: '',
  lastName: '',
  email: '',
  phonenumber: {
    nationality: {
      country: "",
      area_code: '',
    },
    number: ''
  },
  phoneVerified: false,
  avatar: '',
  address: '',
  birthday: '',
  country: '',
  business: {}
}

export const state = proxy({
  user: { ...user },
  isAuthenticated: false,
  setUser(user) {
    state.user = user;
  },
  setAuthentication(value) {
    state.isAuthenticated = value;
  },
  onChangeUserInfo(type, val) {
    state.user[type] = val;
  },
  logout() {
    localStorage.removeItem('token');
    state.user = { ...user };
    state.isAuthenticated = false;
  },
});
